import PropTypes from 'prop-types';
import React from 'react';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import {
  ListaCartaServicosBox, ListaCartaServicosSecretaria, ListaCartaServicosTitulo,
} from './ListaCartaServicosEstilo';

const ListaCartaServicos = ({
  Cor, secretaria, servico,
}) => (
  <ListaCartaServicosBox corFundo={Cor}>
    <ListaCartaServicosTitulo>
      {servico}
    </ListaCartaServicosTitulo>
    <ListaCartaServicosSecretaria>
      {secretaria}
    </ListaCartaServicosSecretaria>
  </ListaCartaServicosBox>
);

ListaCartaServicos.propTypes = {
  Cor: PropTypes.string,
  secretaria: PropTypes.string,
  servico: PropTypes.string,
};

ListaCartaServicos.defaultProps = {
  Cor: '',
  secretaria: '',
  servico: '',
};

export default ListaCartaServicos;
